module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/xheada3-55cbf9919a6650f7119c88a6bc6d0b64.jpg";